<template>
  <div class="return-steps">
    <div v-for="step in steps" :key="step.num" class="return-step">
      <div class="step-num">{{ step.num }}</div>
      <div class="step-body">
        <div class="step-title">{{ step.title }}</div>
        <div class="step-desc" v-html="step.desc"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReturnSteps",
  props: {
    steps: {
      type: Array,
      required: true,
    },
  },
};
</script>
